import ThemeConfig from './theme'
import AuthGuard from './components/auth/AuthGuard'
import PluginLayout from './components/layout/PluginLayout'
import LoadDetails from './components/load/LoadDetails'

// Initialize Firebase on app load
import './services/firebase'

function App() {
  return (
    <ThemeConfig>
      <AuthGuard>
        <PluginLayout>
          <LoadDetails />
        </PluginLayout>
      </AuthGuard>
    </ThemeConfig>
  )
}

export default App
